var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#085FE5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.984 16A8 8 0 100 8a8.008 8.008 0 007.984 8zm0-14.774A6.774 6.774 0 111.226 8a6.782 6.782 0 016.758-6.774z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26 6.596a.6.6 0 00.6-.6.892.892 0 011.764-.164.9.9 0 01-.46.972A1.944 1.944 0 007.152 8.54v.492a.6.6 0 101.2 0V8.52a.756.756 0 01.376-.688A2.088 2.088 0 105.66 5.984a.6.6 0 00.6.612zM7.752 10.164a.876.876 0 100 1.752.876.876 0 000-1.752z"
  }))));
}

export default SvgHelp;